// // import Registration from "./Registration";
// import { registration } from "../../apis/backend";

// import React, { useState } from "react";
// const Registration = () => {
//   const [userData, setUserData] = useState<any>({
//     newUsername: "",
//     newPassword: "",
//     newFirstName: "",
//     newLastName: "",
//     newEmail: "",
//     // adminUsername: "",
//     // adminPassword: "",
//     resource: "",
//     user_name: "",
//     user_email: "",
//   });

//   const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
//     e.preventDefault();
//     console.log("Registration form submitted with data:", userData);

//     await registration(userData);
//     // Optionally, you can reset the form after submission
//     setUserData({
//         newUsername: "",
//         newPassword: "",
//         newFirstName: "",
//         newLastName: "",
//         newEmail: "",
//         // adminUsername: "",
//         // adminPassword: "",
//         resource: "",
//         user_name: "",
//         user_email: "",
//         });

//   };

//   return (
//     <div>
//       <form
//         className="border w-15 d-flex flex-column m-auto shadow-sm"
//         style={{ borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }}
//         onSubmit={handleSubmit}
//       >
//         <div
//           className="d-flex justify-content-center"
//           style={{
//             background: "#DCDCDC",
//             borderTopLeftRadius: "10px",
//             borderTopRightRadius: "10px",
//           }}
//         >
//           <h3 className="fs-5 fw-light p-2">Sign Up</h3>
//         </div>
//         <div className="d-flex flex-column gap-4 p-4 align-items-center">
//           <input
//             type="text"
//             className="form-control bg-light border-1"
//             name="newUsername"
//             placeholder="Enter Username"
//             value={userData.newUsername}
//             onChange={(e) =>
//               setUserData({
//                 ...userData,
//                 [e.target.name]: e.target.value,
//               })
//             }
//           />
//           <input
//             type="Enter Password"
//             className="form-control bg-light border-1"
//             name="newPassword"
//             placeholder="Password"
//             value={userData.newPassword}
//             onChange={(e) =>
//               setUserData({
//                 ...userData,
//                 [e.target.name]: e.target.value,
//               })
//             }
//           />
//           <input
//             type="text"
//             className="form-control bg-light border-1"
//             name="newFirstName"
//             placeholder="Enter First Name"
//             value={userData.newFirstName}
//             onChange={(e) =>
//               setUserData({
//                 ...userData,
//                 [e.target.name]: e.target.value,
//               })
//             }
//           />
//           <input
//             type="text"
//             className="form-control bg-light border-1"
//             name="newLastName"
//             placeholder="Enter Last Name"
//             value={userData.newLastName}
//             onChange={(e) =>
//               setUserData({
//                 ...userData,
//                 [e.target.name]: e.target.value,
//               })
//             }
//           />
//           <input
//             type="email"
//             className="form-control bg-light border-1"
//             name="newEmail"
//             placeholder="Enter Email Address"
//              value={userData.newEmail}

//             onChange={(e) =>
//               setUserData({
//                 ...userData,
//                 [e.target.name]: e.target.value,
//               })
//             }
//           />
//           {/* <input
//             type="string"
//             className="form-control bg-light border-1"
//             name="adminUsername"
//             placeholder="Enter adminUsername"
//             value={userData.adminUsername}

//             onChange={(e) =>
//               setUserData({
//                 ...userData,
//                 [e.target.name]: e.target.value,
//               })
//             }
//           /> */}
//           {/* <input
//             type="password"
//             className="form-control bg-light border-1"
//             name="adminPassword"
//             placeholder="Enter adminPassword"
//             value={userData.adminPassword}

//             onChange={(e) =>
//               setUserData({
//                 ...userData,
//                 [e.target.name]: e.target.value,
//               })
//             }
//           /> */}
//           <input
//             type="string"
//             className="form-control bg-light border-1"
//             name="resource"
//             placeholder="Enter resourceName"
//             value={userData.resource}

//             onChange={(e) =>
//               setUserData({
//                 ...userData,
//                 [e.target.name]: e.target.value,
//               })
//             }
//           />
//           <input
//             type="string"
//             className="form-control bg-light border-1"
//             name="user_name"
//             placeholder="Enter user_name"
//             value={userData.user_name}

//             onChange={(e) =>
//               setUserData({
//                 ...userData,
//                 [e.target.name]: e.target.value,
//               })
//             }
//           />
//           <input
//             type="string"
//             className="form-control bg-light border-1"
//             name="user_email"
//             placeholder="Enter user_email"
//             value={userData.user_email}

//             onChange={(e) =>
//               setUserData({
//                 ...userData,
//                 [e.target.name]: e.target.value,
//               })
//             }
//           />
//           <button
//             type="submit"
//             className="btn text-white w-100"
//             style={{
//               background: "#2D88D4",
//               fontSize: "18px",
//               borderRadius: "10px",
//             }}
//           >
//             Register
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Registration;

// import React, { useState } from "react";
// import { addUser } from "../../apis/backend";

// type Step = 1 | 2;

// interface FormState {
//   email: string;
//   firstName: string;
//   lastName: string;
//   password: string;
//   confirmPassword: string;
// }

// const Registration = () => {
//   const [step, setStep] = useState<Step>(1);

//   const [form, setForm] = useState<FormState>({
//     email: "",
//     firstName: "",
//     lastName: "",
//     password: "",
//     confirmPassword: "",
//   });

//   const handleContinue = (e: React.FormEvent<HTMLFormElement>) => {
//     e.preventDefault();
//     setStep(2);
//   };

//   const handleRegister = async (e: React.FormEvent<HTMLFormElement>) => {
//     e.preventDefault();

//     if (form.password !== form.confirmPassword) {
//       alert("Passwords do not match");
//       return;
//     }

//     const payload = {
//       resourceName: "Users",
//       authMap: {
//         userName: form.email, // username = email
//         email: form.email,
//         firstName: form.firstName,
//         lastName: form.lastName,
//         password: form.password,
//       },
//       resourceMap: {
//         user_name: `${form.firstName} ${form.lastName}`,
//         user_email: form.email,
//       },
//     };

//     try {
//       await addUser(payload);
//       alert("Registration successful");

//       setForm({
//         email: "",
//         firstName: "",
//         lastName: "",
//         password: "",
//         confirmPassword: "",
//       });
//       setStep(1);
//     } catch (err) {
//       console.error(err);
//       alert("Registration failed");
//     }
//   };

//   return (
//     <div>
//       <form
//         className="border w-15 d-flex flex-column m-auto shadow-sm"
//         style={{ borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }}
//         onSubmit={step === 1 ? handleContinue : handleRegister}
//       >
//         {/* HEADER */}
//         <div
//           className="d-flex justify-content-center"
//           style={{
//             background: "#DCDCDC",
//             borderTopLeftRadius: "10px",
//             borderTopRightRadius: "10px",
//           }}
//         >
//           <h3 className="fs-5 fw-light p-2">
//             {step === 1 ? "Register Your Account" : "Set Password"}
//           </h3>
//         </div>

//         {/* BODY */}
//         <div className="d-flex flex-column gap-4 p-4 align-items-center">
//           {/* STEP 1 */}
//           {step === 1 && (
//             <>
//               <input
//                 type="text"
//                 className="form-control bg-light border-1"
//                 placeholder="Enter First Name"
//                 value={form.firstName}
//                 onChange={(e) =>
//                   setForm({ ...form, firstName: e.target.value })
//                 }
//                 required
//               />

//               <input
//                 type="text"
//                 className="form-control bg-light border-1"
//                 placeholder="Enter Last Name"
//                 value={form.lastName}
//                 onChange={(e) =>
//                   setForm({ ...form, lastName: e.target.value })
//                 }
//                 required
//               />

//               <input
//                 type="email"
//                 className="form-control bg-light border-1"
//                 placeholder="Enter Email Address"
//                 value={form.email}
//                 onChange={(e) =>
//                   setForm({ ...form, email: e.target.value })
//                 }
//                 required
//               />
//             </>
//           )}

//           {/* STEP 2 */}
//           {step === 2 && (
//             <>
//               <input
//                 type="password"
//                 className="form-control bg-light border-1"
//                 placeholder="Create Password"
//                 value={form.password}
//                 onChange={(e) =>
//                   setForm({ ...form, password: e.target.value })
//                 }
//                 required
//               />

//               <input
//                 type="password"
//                 className="form-control bg-light border-1"
//                 placeholder="Confirm Password"
//                 value={form.confirmPassword}
//                 onChange={(e) =>
//                   setForm({ ...form, confirmPassword: e.target.value })
//                 }
//                 required
//               />
//             </>
//           )}

//           {/* BUTTON */}
//           <button
//             type="submit"
//             className="btn text-white w-100"
//             style={{
//               background: "#2D88D4",
//               fontSize: "18px",
//               borderRadius: "10px",
//             }}
//           >
//             {step === 1 ? "Continue" : "Register"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Registration;

// import React, { useState } from "react";
// import { addUser } from "../../apis/backend";
// import apiConfig from "../../config/apiConfig";

// type Step = 1 | 2;

// interface FormState {
//   email: string;
//   firstName: string;
//   lastName: string;
//   password: string;
//   confirmPassword: string;
// }

// const Registration = () => {
//   const [step, setStep] = useState<Step>(1);

//   const [form, setForm] = useState<FormState>({
//     email: "",
//     firstName: "",
//     lastName: "",
//     password: "",
//     confirmPassword: "",
//   });

//   const [otp, setOtp] = useState<string[]>(["", "", "", "", "", ""]);
//   const [loading, setLoading] = useState(false);

//   /* =====================
//      STEP 1 – SEND OTP
//   ===================== */
//   const handleContinue = async (e: React.FormEvent<HTMLFormElement>) => {
//     e.preventDefault();

//     if (form.password !== form.confirmPassword) {
//       alert("Passwords do not match");
//       return;
//     }

//     try {
//       setLoading(true);

//       const res = await fetch(
//         `${apiConfig.API_BASE_URL}/auth/send-otp?email=${encodeURIComponent(
//           form.email
//         )}`,
//         {
//           method: "POST",
//         }
//       );

//       if (!res.ok) {
//         const text = await res.text();
//         throw new Error(text);
//       }

//       alert("OTP sent to your email");
//       setStep(2);
//     } catch (err: any) {
//       console.error(err);
//       alert(err.message || "Failed to send OTP");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* =====================
//      STEP 2 – VERIFY OTP
//   ===================== */
//   const handleVerifyOtp = async (e: React.FormEvent<HTMLFormElement>) => {
//     e.preventDefault();

//     const enteredOtp = otp.join("");

//     if (enteredOtp.length !== 6) {
//       alert("Please enter complete OTP");
//       return;
//     }

//     try {
//       setLoading(true);

//       const verifyRes = await fetch(
//         `${apiConfig.API_BASE_URL}/auth/verify-otp?email=${encodeURIComponent(
//           form.email
//         )}&otp=${enteredOtp}`,
//         {
//           method: "POST",
//         }
//       );

//       if (!verifyRes.ok) {
//         const text = await verifyRes.text();
//         throw new Error(text);
//       }

//       // OTP verified → create user
//       const payload = {
//         resourceName: "Users",
//         authMap: {
//           userName: form.email,
//           email: form.email,
//           firstName: form.firstName,
//           lastName: form.lastName,
//           password: form.password,
//         },
//         resourceMap: {
//           user_name: `${form.firstName} ${form.lastName}`,
//           user_email: form.email,
//         },
//       };

//       await addUser(payload);

//       alert("Registration successful");

//       setForm({
//         email: "",
//         firstName: "",
//         lastName: "",
//         password: "",
//         confirmPassword: "",
//       });
//       setOtp(["", "", "", "", "", ""]);
//       setStep(1);
//     } catch (err: any) {
//       console.error(err);
//       alert(err.message || "OTP verification failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleOtpChange = (value: string, index: number) => {
//     if (!/^\d?$/.test(value)) return;

//     const updatedOtp = [...otp];
//     updatedOtp[index] = value;
//     setOtp(updatedOtp);
//   };

//   return (
//     <div>
//       <form
//         className="border d-flex flex-column m-auto shadow-sm"
//         style={{
//           width: "420px",
//           borderTopLeftRadius: "10px",
//           borderTopRightRadius: "10px",
//         }}
//         onSubmit={step === 1 ? handleContinue : handleVerifyOtp}
//       >
//         {/* HEADER */}
//         <div
//           className="d-flex justify-content-center"
//           style={{
//             background: "#DCDCDC",
//             borderTopLeftRadius: "10px",
//             borderTopRightRadius: "10px",
//           }}
//         >
//           <h3 className="fs-5 fw-light p-2">
//             {step === 1
//               ? "Register Your Account"
//               : "Verify your Email Address"}
//           </h3>
//         </div>

//         {/* BODY */}
//         <div className="d-flex flex-column gap-3 p-4 align-items-center">
//           {/* STEP 1 */}
//           {step === 1 && (
//             <>
//               <input
//                 type="text"
//                 className="form-control bg-light border-1"
//                 placeholder="Enter First Name"
//                 value={form.firstName}
//                 onChange={(e) =>
//                   setForm({ ...form, firstName: e.target.value })
//                 }
//                 required
//               />

//               <input
//                 type="text"
//                 className="form-control bg-light border-1"
//                 placeholder="Enter Last Name"
//                 value={form.lastName}
//                 onChange={(e) =>
//                   setForm({ ...form, lastName: e.target.value })
//                 }
//                 required
//               />

//               <input
//                 type="email"
//                 className="form-control bg-light border-1"
//                 placeholder="Enter Email Address"
//                 value={form.email}
//                 onChange={(e) =>
//                   setForm({ ...form, email: e.target.value })
//                 }
//                 required
//               />

//               <input
//                 type="password"
//                 className="form-control bg-light border-1"
//                 placeholder="Create Password"
//                 value={form.password}
//                 onChange={(e) =>
//                   setForm({ ...form, password: e.target.value })
//                 }
//                 required
//               />

//               <input
//                 type="password"
//                 className="form-control bg-light border-1"
//                 placeholder="Confirm Password"
//                 value={form.confirmPassword}
//                 onChange={(e) =>
//                   setForm({ ...form, confirmPassword: e.target.value })
//                 }
//                 required
//               />
//             </>
//           )}

//           {/* STEP 2 – OTP */}
//           {step === 2 && (
//             <>
//               <p className="text-center text-muted">
//                 We sent a 6 digit code to your email
//               </p>

//               <div className="d-flex gap-2">
//                 {otp.map((digit, index) => (
//                   <input
//                     key={index}
//                     className="form-control text-center"
//                     style={{ width: "45px" }}
//                     maxLength={1}
//                     value={digit}
//                     onChange={(e) =>
//                       handleOtpChange(e.target.value, index)
//                     }
//                   />
//                 ))}
//               </div>
//             </>
//           )}

//           {/* BUTTON */}
//           <button
//             type="submit"
//             className="btn text-white w-100 mt-3"
//             disabled={loading}
//             style={{
//               background: "#2D88D4",
//               fontSize: "18px",
//               borderRadius: "10px",
//             }}
//           >
//             {loading
//               ? "Please wait..."
//               : step === 1
//               ? "Continue"
//               : "Submit"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Registration;

import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { registerWithOtp } from "../../apis/backend";
import apiConfig from "../../config/apiConfig";
import { toast } from "../../utils/toast";
import ReCAPTCHA from "react-google-recaptcha";
import { getConfig, isCaptchaEnabled } from "../../config/runtimeConfig";
import "./Registration.css";

type Step = 1 | 2;

interface FormState {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  mobileNumber: string;
  qualification: string;
}

const Registration = () => {
  const navigate = useNavigate(); // ✅ added

  const [step, setStep] = useState<Step>(1);

  const [form, setForm] = useState<FormState>({
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    confirmPassword: "",
    mobileNumber: "",
    qualification: "", // Default value
  });

  const [passwordError, setPasswordError] = useState<string>("");
  const [confirmPasswordError, setConfirmPasswordError] = useState<string>("");
  const [mobileError, setMobileError] = useState<string>("");
  const [otp, setOtp] = useState<string[]>(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [nameInput, setNameInput] = useState("");
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const captchaRef = useRef<ReCAPTCHA>(null);



  /* =====================
     STEP 1 – SEND OTP
  ===================== */
  const handleContinue = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (passwordError || mobileError || confirmPasswordError) {
      toast.error("Please fix form errors before continuing.");
      return;
    }

    // Regex check (redundant safety check)
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d).{8,}$/;
    if (!passwordRegex.test(form.password)) {
      toast.error(
        "Password must be at least 8 characters long and contain at least one uppercase letter and one number.",
      );
      return;
    }

    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(form.mobileNumber)) {
      toast.error("Please enter a valid 10-digit mobile number.");
      return;
    }

    if (form.password !== form.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    if (isCaptchaEnabled() && !captchaToken) {
      toast.error("Please complete the CAPTCHA verification.");
      return;
    }

    try {
      setLoading(true);

      const captchaParam = isCaptchaEnabled() && captchaToken
        ? `&captchaToken=${encodeURIComponent(captchaToken)}`
        : "";

      const res = await fetch(
        `${apiConfig.API_BASE_URL}/auth/send-otp?email=${encodeURIComponent(
          form.email,
        )}${captchaParam}`,
        { method: "POST" },
      );

      if (!res.ok) {
        const errorText = await res.text();
        // Reset captcha on failure so user must re-verify
        captchaRef.current?.reset();
        setCaptchaToken(null);
        throw new Error(errorText);
      }

      toast.success("OTP sent to your email");
      setStep(2);
    } catch (err: any) {
      toast.error(err.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  /* =====================
     STEP 2 – VERIFY OTP + CREATE USER (Atomic)
  ===================== */
  const handleVerifyOtp = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const enteredOtp = otp.join("");

    if (enteredOtp.length !== 6) {
      toast.error("Please enter complete OTP");
      return;
    }

    try {
      setLoading(true);

      // Single atomic call: verify OTP + create user and assign role on the backend
      await registerWithOtp({
        email: form.email,
        otp: enteredOtp,
        resourceName: "Users",
        authMap: {
          userName: form.email,
          email: form.email,
          firstName: form.firstName,
          lastName: form.lastName,
          password: form.password,
        },
        resourceMap: {
          user_name: `${form.firstName} ${form.lastName}`,
          user_email: form.email,
          mobile_number: form.mobileNumber,
          qualification: form.qualification,
        },
      }, "Student");

      toast.success("Registration successful. Please login to continue.");

      /* ========= REDIRECT TO LOGIN ========= */
      navigate("/");
    } catch (err: any) {
      toast.error(err.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  const [timer, setTimer] = useState<number>(300);
  const [canResend, setCanResend] = useState<boolean>(false);

  // Timer effect for OTP countdown
  React.useEffect(() => {
    let interval: NodeJS.Timeout;
    if (step === 2 && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            setCanResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [step, timer]);

  const handleResendOtp = async () => {
    try {
      setLoading(true);
      const res = await fetch(
        `${apiConfig.API_BASE_URL}/auth/send-otp?email=${encodeURIComponent(
          form.email,
        )}`,
        { method: "POST" },
      );

      if (!res.ok) {
        throw new Error(await res.text());
      }

      toast.success("OTP resent to your email");
      setTimer(300);
      setCanResend(false);
    } catch (err: any) {
      toast.error(err.message || "Failed to resend OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleOtpChange = (value: string, index: number) => {
    if (!/^\d?$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    // Auto-focus next input
    if (value && index < otp.length - 1) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      nextInput?.focus();
    }
  };

  const handleOtpKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      prevInput?.focus();
    }
  };

  const handleOtpPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pastedData = e.clipboardData.getData("text").trim();
    if (!/^\d+$/.test(pastedData)) return; // Only process if it's numeric

    const digits = pastedData.slice(0, 6).split("");
    const newOtp = [...otp];

    digits.forEach((digit, i) => {
      if (i < 6) newOtp[i] = digit;
    });

    setOtp(newOtp);

    // Focus the last input filled or the next one
    const lastFilledIndex = Math.min(digits.length - 1, 5);
    const nextIndex = Math.min(digits.length, 5);
    const focusTarget = document.getElementById(`otp-input-${nextIndex}`);
    focusTarget?.focus();

    e.preventDefault();
  };

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const inputStyle: React.CSSProperties = {
    padding: "14px",
    borderRadius: "10px",
  };

  const otpInputStyle: React.CSSProperties = {
    width: "50px",
    height: "50px",
    padding: "10px",
    borderRadius: "10px",
    fontSize: "20px",
    fontWeight: "600",
    textAlign: "center",
  };

  return (
    <div
      className="d-flex flex-column align-items-center"
      style={{
        minHeight: "100vh",
        width: "min(30vw, 400px)",
        background: "#ffffff",
        padding: "60px 0", 
        margin: "0 auto", /* Center horizontally */
      }}
    >
      <form
        className="w-100 mw-400 p-4"
        onSubmit={step === 1 ? handleContinue : handleVerifyOtp}
      >
        {/* STEP 1: Register Form */}
        {step === 1 && (
          <>
            <h3 className="text-center text-primary fw-bold mb-4 mt-4">
              Registration
            </h3>

            <div className="mb-3">
              <div className="custom-tooltip-wrapper">
                <input
                  type="text"
                  className="form-control bg-light border-1"
                  placeholder="Candidate Full Name"
                  value={nameInput}
                  onChange={(e) => {
                    const val = e.target.value;
                    setNameInput(val);
                    const parts = val.trim().split(" ");
                    setForm({
                      ...form,
                      firstName: parts[0] || "",
                      lastName: parts.slice(1).join(" ") || "",
                    });
                  }}
                  style={inputStyle}
                  required
                />
                <div className="custom-tooltip-content">
                  Candidate's name as per 12th class certificate.
                  <br />
                  <strong>Note:</strong> Once registered, the name cannot be modified.
                </div>
              </div>
            </div>

            <div style={{ height: "1px" }}></div>

            <div className="mb-3">
              <div className="custom-tooltip-wrapper">
                <input
                  type="email"
                  className="form-control bg-light border-1"
                  placeholder="Candidate Email ID"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  style={inputStyle}
                  required
                />
                <div className="custom-tooltip-content">
                  Email ID for correspondence
                </div>
              </div>
            </div>

            <div style={{ height: "1px" }}></div>

            <div style={{ height: "1px" }}></div>

            <div className="mb-3">
              <div className="custom-tooltip-wrapper">
                <input
                  type="tel"
                  className="form-control bg-light border-1"
                  placeholder="Candidate Mobile Number"
                  value={form.mobileNumber}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, ""); // Only allow digits
                    setForm({ ...form, mobileNumber: val });

                    // Real-time validation
                    if (val && val.length !== 10) {
                      setMobileError("Mobile number must be exactly 10 digits.");
                    } else {
                      setMobileError("");
                    }
                  }}
                  style={{
                    ...inputStyle,
                    borderColor: mobileError ? "red" : "",
                  }}
                  maxLength={10}
                  required
                />
                <div className="custom-tooltip-content">
                  Mobile Number for correspondence
                </div>
              </div>
              {mobileError && (
                <small className="text-danger ps-2">{mobileError}</small>
              )}
            </div>

            {/* <div className="mb-3">
              <select
                className="form-control bg-light border-1"
                value={form.qualification}
                onChange={(e) => setForm({ ...form, qualification: e.target.value })}
                style={inputStyle}
                required
              >
                <option value="" style={{color: "Red"}} disabled >Program Applying For</option>
                <option value="MTech">MTech</option>
                <option value="BTech/IMTech">BTech/IMTech</option>
              </select>
            </div> */}

            <div className="mb-3">
              <select
                className="form-control border-1"
                value={form.qualification}
                onChange={(e) =>
                  setForm({ ...form, qualification: e.target.value })
                }
                style={{
                  ...inputStyle,
                  color: form.qualification ? "#000" : "#5b5959",
                  backgroundColor: form.qualification ? "#f5f5f5" : "#f5f5f5",
                }}
                required
              >
                <option value="" disabled>
                  Programme Applying For
                </option>
                <option value="M.Tech.">M.Tech</option>
                <option value="B.Tech/ Integrated M.Tech.">B.Tech / Integrated M.Tech</option>
              </select>
            </div>

            <div className="mb-3">
              <input
                type="password"
                className="form-control bg-light border-1"
                placeholder="Password"
                value={form.password}
                onChange={(e) => {
                  const val = e.target.value;
                  setForm({ ...form, password: val });
                  // Real-time validation
                  const passwordRegex = /^(?=.*[A-Z])(?=.*\d).{8,}$/;
                  if (val && !passwordRegex.test(val)) {
                    setPasswordError(
                      "At least 8 characters, 1 uppercase letter, 1 number.",
                    );
                  } else {
                    setPasswordError("");
                  }
                  if (form.confirmPassword && val !== form.confirmPassword) {
                    setConfirmPasswordError("Passwords do not match");
                  } else {
                    setConfirmPasswordError("");
                  }
                }}
                style={{
                  ...inputStyle,
                  borderColor: passwordError ? "red" : "",
                }}
                required
              />
              {passwordError && (
                <small className="text-danger ps-2">{passwordError}</small>
              )}
            </div>

            <div style={{ height: "1px" }}></div>

            <div className="mb-4">
              <input
                type="password"
                className="form-control bg-light border-1"
                placeholder="Confirm Password"
                value={form.confirmPassword}
                onChange={(e) => {
                  const val = e.target.value;
                  setForm({ ...form, confirmPassword: val });
                  if (form.password && val !== form.password) {
                    setConfirmPasswordError("Passwords do not match");
                  } else {
                    setConfirmPasswordError("");
                  }
                }}
                style={{
                  ...inputStyle,
                  borderColor: confirmPasswordError ? "red" : "",
                }}
                required
              />
              {confirmPasswordError && (
                <small className="text-danger ps-2">{confirmPasswordError}</small>
              )}
            </div>

            {/* reCAPTCHA — only rendered when enabled AND site key is present */}
            {isCaptchaEnabled() && (
              <div className="mb-3 d-flex justify-content-center">
                <ReCAPTCHA
                  ref={captchaRef}
                  sitekey={getConfig().RECAPTCHA_SITE_KEY}
                  onChange={(token) => setCaptchaToken(token)}
                  onExpired={() => setCaptchaToken(null)}
                  onErrored={() => {
                    setCaptchaToken(null);
                    toast.error("CAPTCHA error. Please try again.");
                  }}
                />
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary w-100 rounded-3 py-2 fs-6"
              style={{
                background: "#2D88D4",
              }}
              disabled={loading}
            >
              {loading ? "Please wait..." : "Register"}
            </button>

            <div className="text-center mt-3">
              <a href="/" className="text-decoration-none small text-primary">
                Already have an account? Login
              </a>
            </div>
          </>
        )}

        {/* STEP 2: Verify Email Form */}
        {step === 2 && (
          <>
            <h3 className="text-center text-primary fw-bold mb-3">
              Verify your Email Address
            </h3>

            <p className="text-center text-muted small mb-4">
              We sent you a 6 digit code to verify
              <br />
              your email address (
              <span className="text-primary">{form.email}</span>
              ).
              <br />
              Enter in the field below.
            </p>

            {/* OTP Input Fields */}
            <div className="d-flex justify-content-center gap-3 mb-4">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  type="text"
                  className="form-control bg-light border-1 text-center"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target.value, index)}
                  onKeyDown={(e) => handleOtpKeyDown(e, index)}
                  onPaste={handleOtpPaste}
                  style={otpInputStyle}
                />
              ))}
            </div>

            {/* Resend and Timer */}
            <div className="text-center mb-4">
              <p className="text-muted small mb-1">
                Didn't get the code?{" "}
                <button
                  type="button"
                  onClick={handleResendOtp}
                  disabled={!canResend || loading}
                  className="btn btn-link p-0 text-decoration-none small"
                  style={{
                    color: canResend ? "#2D88D4" : "#9ca3af",
                    fontWeight: "600",
                    cursor: canResend ? "pointer" : "not-allowed",
                  }}
                >
                  Resend
                </button>
              </p>
              <p className="text-muted small">
                Expires in{" "}
                <span className="text-primary fw-bold">
                  {formatTime(timer)}
                </span>
              </p>
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100 rounded-3 py-2 fs-6"
              style={{
                background: "#2D88D4",
              }}
              disabled={loading}
            >
              {loading ? "Please wait..." : "Submit"}
            </button>
          </>
        )}
      </form>
    </div>
  );
};

export default Registration;
